import { render, staticRenderFns } from "./ReportSells.vue?vue&type=template&id=08b7456a&"
import script from "./ReportSells.vue?vue&type=script&lang=js&"
export * from "./ReportSells.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports